import React from 'react';
import { Link } from 'react-router-dom';
import { FiFileText, FiDownload, FiCheckSquare } from 'react-icons/fi';

const DownloadItem = ({ icon, title, description, link, isExternal }) => (
  <div className="border rounded-lg p-5 flex items-start space-x-4 bg-white hover:shadow-md transition-shadow">
    <div className="text-blue-500 text-2xl mt-1">{icon}</div>
    <div>
      <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
      <p className="text-gray-600 mt-1 mb-3">{description}</p>
      {isExternal ? (
        <a href={link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-blue-600 font-semibold hover:underline">
          डाउनलोड करें <FiDownload className="ml-2" />
        </a>
      ) : (
        <Link to={link} className="inline-flex items-center text-blue-600 font-semibold hover:underline">
          पेज पर जाएँ <FiDownload className="ml-2" />
        </Link>
      )}
    </div>
  </div>
);

const Downloads = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">डाउनलोड सेक्शन</h1>
      <div className="space-y-6">
        <DownloadItem
          icon={<FiFileText />}
          title="खाली प्रमाण पत्र प्रारूप"
          description="इसे प्रिंट करें और हाथ से भरकर ग्राम प्रधान से हस्ताक्षर करवाएं। यह तत्काल ज़रूरतों के लिए है।"
          link="/manual-certificate"
        />
        <DownloadItem
          icon={<FiCheckSquare />}
          title="डिजिटल प्रमाण पत्र डाउनलोड करें"
          description="अपने स्वीकृत डिजिटल प्रमाण पत्र को डाउनलोड या प्रिंट करने के लिए स्टेटस चेक पेज पर अपना सीरियल नंबर डालें।"
          link="/status-check"
        />
         <DownloadItem
          icon={<FiFileText />}
          title="ग्राम का इतिहास"
          description="सिखेड़ा गाँव के इतिहास को पढ़ें और PDF के रूप में सेव या प्रिंट करें।"
          link="/history"
        />
      </div>
    </div>
  );
};

export default Downloads;
